import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { getIn } from 'formik';
import useStyles from './Select.styled';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

const MaterialSelectField = ({
  field: { name, value = '', onChange },
  disabled,
  form: { errors, touched },
  fullWidth,
  readOnly,
  options,
  placeholder,
  handleChange,
  customSelectStyles,
  customLabelStyles,
  asyncErrors,
  formStyle,
  required,
  inputProps,
  editable = true,
  ...props
}) => {
  const classes = useStyles();

  const handleShowError = () => {
    if (asyncErrors) {
      return asyncErrors;
    } else if (getIn(errors, name) && getIn(touched, name)) {
      return getIn(errors, name);
    }
  };

  return (
    <FormControl
      style={formStyle}
      disabled={disabled}
      className={classes.formControl}
      error={getIn(errors, name) && getIn(touched, name)}
    >
      {placeholder && (
        <InputLabel id={name} className={clsx(customLabelStyles)}>
          {placeholder + (required ? ' * ' : '')}
        </InputLabel>
      )}
      {editable ? (
        <Select
          name={name}
          value={value}
          labelId={name}
          classes={{
            root: classes.menuItem,
          }}
          required={required}
          autoWidth={true}
          onChange={(e) => {
            onChange(e);
            if (handleChange) {
              handleChange(e);
            }
          }}
          fullWidth={fullWidth}
          inputProps={{ readOnly: readOnly, ...inputProps }}
          className={clsx(classes.select, customSelectStyles)}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          {...props}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              classes={{
                root: classes.menuItemOption,
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <span className={classes.nonEditable}>
          {value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()}
        </span>
      )}
      {handleShowError() && (
        <FormHelperText
          style={{
            marginLeft: 16,
          }}
          error={true}
        >
          {handleShowError()}
        </FormHelperText>
      )}
    </FormControl>
  );
};

MaterialSelectField.propTypes = {
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  fullWidth: PropTypes.bool,
  inputProps: PropTypes.object,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  asyncErrors: PropTypes.string,
  customSelectStyles: PropTypes.any,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  formStyle: PropTypes.any,
  customLabelStyles: PropTypes.any,
  options: PropTypes.array.isRequired,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

MaterialSelectField.defaultProps = {
  readOnly: false,
  required: false,
  fullWidth: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
  },
  formStyle: {},
  inputProps: {},
  variant: 'standard',
  customLabelStyles: {},
  customSelectStyles: {},
};

export default MaterialSelectField;
